<template>
  <el-dialog
    :close-on-click-modal="false"
    title="照片凭证"
    :lock-scroll="true"
    :visible.sync="dialogFormVisible"
  >
    <section v-loading="getDetailLoading">
        <section v-for="(item, index, key) in files" :key="key">
          <img width="100%" :src="item.url" alt />
        </section>
    </section>
    <section slot="footer" class="dialog-footer">
      <el-button @click="dialogFormVisible = false">取消</el-button>
    </section>
  </el-dialog>
</template>

<script>
import {
  getFileUrl,
} from 'api';
export default {
  data () {
    return {
      getDetailLoading: false, // 获取详情loading
      dialogFormVisible: false,
      originData: {},
      files: [],
    };
  },
  methods: {

    /**
     * @param {Object} item 修改的项
     * @returns {void}
     * @description 打开弹窗并初始化数据
     */
    show (flowIds) {
      const _this = this;
      _this.files = [];
      this.dialogFormVisible = true; // 打开弹窗
      this.getDetailLoading = true;
      this.$nextTick(async () => {
        if (flowIds) {
          const imgRes = await getFileUrl({
            flowIds: flowIds,
          });
          imgRes.items.forEach((item) => {
            _this.files.push({
              id: item.flowId,
              url: item.fullPath,
            });
          });
          this.getDetailLoading = false;
        } else {
          this.getDetailLoading = false;
        }
      });
    },
  },
};
</script>

<style>
</style>
